var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxRemoveIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grid_system"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.8,17.2c0.2,0.2,0.5,0.4,0.8,0.4s0.6-0.1,0.8-0.4l6.4-6.4l6.4,6.4c0.2,0.2,0.6,0.4,0.8,0.4s0.6-0.1,0.8-0.4 c0.5-0.5,0.5-1.2,0-1.7l-6.4-6.4L17,2.8c0.5-0.5,0.5-1.2,0-1.7s-1.2-0.5-1.7,0L8.9,7.5L2.5,1.1C2,0.6,1.3,0.6,0.8,1.1 s-0.5,1.2,0,1.7l6.4,6.4l-6.4,6.4C0.3,16,0.3,16.8,0.8,17.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxRemoveIcon);
export default __webpack_public_path__ + "static/media/box-remove-Icon.c8e661d7efeb22e68ed0f6e3444a53e0.svg";
export { ForwardRef as ReactComponent };